// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-card-page {
  background-color: rgba(var(--white));
}
.brand-card-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .brand-card-page__header {
    height: 2rem;
    padding: 2rem 1rem;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: rgba(var(--white));
  }
}
.brand-card-page__content {
  padding-bottom: 7.5rem;
}
@media (max-width: 768px) {
  .brand-card-page__content {
    padding-bottom: 0;
  }
}
.brand-card-page__content-info {
  display: flex;
  gap: 2.5rem;
  margin: 3.5rem 6.875rem 0;
  cursor: pointer;
}
@media (max-width: 768px) {
  .brand-card-page__content-info {
    margin: 0 1rem;
    flex-direction: column;
    gap: 1rem;
  }
}
.brand-card-page__content-info-text {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.brand-card-page__content-info_without-descr {
  align-items: center;
}
@media (max-width: 768px) {
  .brand-card-page__content-info_without-descr {
    align-items: normal;
  }
}
.brand-card-page__content-info:hover .brand-card-page__logo-wrapper {
  box-shadow: 0 0 12px 0 rgba(24, 28, 41, 0.08);
}
.brand-card-page__content-info:hover .brand-card-page__title {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
  color: rgba(var(--grey-600));
}
.brand-card-page__content-products {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 7.5rem;
}
@media (max-width: 768px) {
  .brand-card-page__content-products {
    margin-top: 4rem;
    gap: 1.5rem;
  }
}
.brand-card-page__content-products-title {
  font-size: 2rem;
  line-height: 1.3125;
  font-weight: 500;
  color: rgba(var(--grey-800));
  padding: 0 6.875rem 0;
}
@media (max-width: 768px) {
  .brand-card-page__content-products-title {
    font-size: 1.5rem;
    padding: 0 1rem 0;
  }
}
.brand-card-page__content-products-items {
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  height: max-content;
  grid-gap: 2.5rem;
  box-sizing: border-box;
  overflow-x: auto;
  padding: 0 6.875rem 0;
}
@media (max-width: 768px) {
  .brand-card-page__content-products-items {
    grid-gap: 1.5rem;
    padding: 0 1rem 0;
  }
}
.brand-card-page__content-products-items::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.brand-card-page__breadcrumbs {
  padding: 3rem 6.875rem 1.5rem;
}
.brand-card-page__logo {
  height: 7.8125rem;
  width: 7.8125rem;
  object-fit: contain;
}
@media (max-width: 768px) {
  .brand-card-page__logo {
    height: 3.9rem;
    width: 3.9rem;
  }
}
.brand-card-page__logo-wrapper {
  height: 10rem;
  width: 10rem;
  border-radius: 0.5rem;
  border: 0.58px solid rgba(var(--blue-grey-300));
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .brand-card-page__logo-wrapper {
    height: 5rem;
    width: 5rem;
  }
}
.brand-card-page__title {
  font-size: 2rem;
  line-height: 1.5;
  font-weight: 400;
  color: rgba(var(--grey-800));
  font-family: var(--merriweather);
  text-transform: capitalize;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}
@media (max-width: 768px) {
  .brand-card-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
  }
}
.brand-card-page__description {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
  color: rgba(var(--grey-600));
  max-width: 735px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
@media (max-width: 768px) {
  .brand-card-page__description {
    font-size: 0.875rem;
    line-height: 1.57;
    max-width: max-content;
  }
}
.brand-card-page__description p:first-child {
  margin-top: 0;
}
.brand-card-page__description p:last-child {
  margin-bottom: 0;
}
.brand-card-page__description-more {
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
  color: rgba(var(--blue));
}
.brand-card-page__description_all {
  display: block;
  overflow: visible;
}
.brand-card-page__description_vertical {
  -webkit-box-orient: vertical;
}`, "",{"version":3,"sources":["webpack://./src/pages/BrandCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,MAAA;IACA,UAAA;IACA,oCAAA;EAEJ;AACF;AACE;EACE,sBAAA;AACJ;AACI;EAHF;IAII,iBAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;AAEN;AAAM;EANF;IAOI,cAAA;IACA,sBAAA;IACA,SAAA;EAGN;AACF;AADM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAGR;AAAM;EACE,mBAAA;AAER;AAAQ;EAHF;IAII,mBAAA;EAGR;AACF;AACQ;EACE,6CAAA;AACV;AAEQ;EACE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,4BAAA;AAAV;AAKI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAHN;AAKM;EANF;IAOI,gBAAA;IACA,WAAA;EAFN;AACF;AAIM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AAFR;AAIQ;EAPF;IAQI,iBAAA;IACA,iBAAA;EADR;AACF;AAIM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBAAA;AAFR;AAIQ;EAVF;IAWI,gBAAA;IACA,iBAAA;EADR;AACF;AAGQ;EACE,QAAA;EACA,SAAA;AADV;AAOE;EACE,6BAAA;AALJ;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AAQI;EALF;IAMI,cAAA;IACA,aAAA;EALJ;AACF;AAOI;EACE,aAAA;EACA,YAAA;EACA,qBAAA;EACA,+CAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AALN;AAOM;EAVF;IAWI,YAAA;IACA,WAAA;EAJN;AACF;AAQE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gCAAA;EACA,0BAAA;EACA,qBAAA;EACA,gCAAA;AANJ;AAQI;EAVF;IAWI,iBAAA;IACA,gBAAA;EALJ;AACF;AAQE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EAQA,oBAAA;EACA,qBAAA;EACA,gBAAA;AAbJ;AAKI;EAPF;IAQI,mBAAA;IACA,iBAAA;IACA,sBAAA;EAFJ;AACF;AASM;EACE,aAAA;AAPR;AASM;EACE,gBAAA;AAPR;AAWI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AATN;AAYI;EACE,cAAA;EACA,iBAAA;AAVN;AAaI;EACE,4BAAA;AAXN","sourcesContent":[".brand-card-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      height: 2rem;\n      padding: 2rem 1rem;\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      background-color: rgba(var(--white));\n    }\n  }\n\n  &__content {\n    padding-bottom: 7.5rem;\n\n    @media (max-width: 768px) {\n      padding-bottom: 0;\n    }\n\n    &-info {\n      display: flex;\n      gap: 2.5rem;\n      margin: 3.5rem 6.875rem 0;\n      cursor: pointer;\n\n      @media (max-width: 768px) {\n        margin: 0 1rem;\n        flex-direction: column;\n        gap: 1rem;\n      }\n\n      &-text {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n      }\n\n      &_without-descr {\n        align-items: center;\n\n        @media (max-width: 768px) {\n          align-items: normal;\n        }\n      }\n\n      &:hover {\n        .brand-card-page__logo-wrapper {\n          box-shadow: 0 0 12px 0 rgba(24, 28, 41, 0.08);\n        }\n\n        .brand-card-page__title {\n          text-decoration: underline;\n          text-decoration-thickness: 2px;\n          text-underline-offset: 3px;\n          color: rgba(var(--grey-600));\n        }\n      }\n    }\n\n    &-products {\n      display: flex;\n      flex-direction: column;\n      gap: 2.5rem;\n      margin-top: 7.5rem;\n\n      @media (max-width: 768px) {\n        margin-top: 4rem;\n        gap: 1.5rem;\n      }\n\n      &-title {\n        font-size: 2rem;\n        line-height: 1.3125;\n        font-weight: 500;\n        color: rgba(var(--grey-800));\n        padding: 0 6.875rem 0;\n\n        @media (max-width: 768px) {\n          font-size: 1.5rem;\n          padding: 0 1rem 0;\n        }\n      }\n\n      &-items {\n        display: grid;\n        grid-auto-flow: column;\n        width: 100%;\n        height: max-content;\n        grid-gap: 2.5rem;\n        box-sizing: border-box;\n        overflow-x: auto;\n        padding: 0 6.875rem 0;\n\n        @media (max-width: 768px) {\n          grid-gap: 1.5rem;\n          padding: 0 1rem 0;\n        }\n\n        &::-webkit-scrollbar {\n          width: 0;\n          height: 0;\n        }\n      }\n    }\n  }\n\n  &__breadcrumbs {\n    padding: 3rem 6.875rem 1.5rem;\n  }\n\n  &__logo {\n    height: 7.8125rem;\n    width: 7.8125rem;\n    object-fit: contain;\n\n    @media (max-width: 768px) {\n      height: 3.9rem;\n      width: 3.9rem;\n    }\n\n    &-wrapper {\n      height: 10rem;\n      width: 10rem;\n      border-radius: 0.5rem;\n      border: 0.58px solid rgba(var(--blue-grey-300));\n      transition: all 0.2s ease-in-out;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      @media (max-width: 768px) {\n        height: 5rem;\n        width: 5rem;\n      }\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.5;\n    font-weight: 400;\n    color: rgba(var(--grey-800));\n    font-family: var(--merriweather);\n    text-transform: capitalize;\n    text-decoration: none;\n    transition: all 0.2s ease-in-out;\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n    }\n  }\n\n  &__description {\n    font-size: 1rem;\n    line-height: 1.625;\n    font-weight: 400;\n    color: rgba(var(--grey-600));\n    max-width: 735px;\n\n    @media (max-width: 768px) {\n      font-size: 0.875rem;\n      line-height: 1.57;\n      max-width: max-content;\n    }\n\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    overflow: hidden;\n\n    p {\n      &:first-child {\n        margin-top: 0;\n      }\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    &-more {\n      font-size: 1rem;\n      line-height: 1.625;\n      font-weight: 400;\n      color: rgba(var(--blue));\n    }\n\n    &_all {\n      display: block;\n      overflow: visible;\n    }\n\n    &_vertical {\n      -webkit-box-orient: vertical;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
